/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Avatar, AvatarGroup, Box, Typography } from '@mui/material';

/* Shared */
import { LightTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

const SSOAvatar = ({ config, noCount, showText }) =>
    !noCount && config.coverage ? (
        <Avatar
            sx={{
                backgroundColor: 'avatar.sso.backgroundColor',
                marginRight: '8px'
            }}
            data-testid="ssoAvatarIcon"
        >
            <Box
                display="flex"
                alignItems="center"
                sx={{ paddingLeft: '4px', paddingRight: '4px' }}
            >
                {config.icon}
                {showText && (
                    <Typography
                        ml="4px"
                        sx={{
                            color: 'avatar.sso.color',
                            fontSize: FontSizes[0]
                        }}
                    >
                        {config.coverage}
                    </Typography>
                )}
            </Box>
        </Avatar>
    ) : (
        <Avatar
            sx={{
                backgroundColor: 'avatar.ssoSecondary.backgroundColor',
                marginRight: '8px'
            }}
        >
            {config.icon}
        </Avatar>
    );

export const SSOIcons = ({ data, noCount }) => {
    const { googleSsoCount, microsoftSsoCount } = data;
    const { t } = useTranslation();

    const ssoConfig = {
        google: {
            coverage: googleSsoCount,
            icon: (
                <IconWithVariant
                    key="googleSSO"
                    variant={
                        !noCount && googleSsoCount
                            ? 'avatarQuaternary'
                            : 'avatarSecondary'
                    }
                    src="Google"
                    size={FontSizes[1]}
                    wrapperProps={{
                        display: 'flex',
                        justifyContent: 'left'
                    }}
                />
            ),
            label: t('Common.google_sso')
        },
        microsoftSSO: {
            coverage: microsoftSsoCount,
            icon: (
                <IconWithVariant
                    key="microsoftSSO"
                    variant={
                        !noCount && microsoftSsoCount
                            ? 'avatarQuaternary'
                            : 'avatarSecondary'
                    }
                    src="Microsoft"
                    size={FontSizes[1]}
                    wrapperProps={{
                        display: 'flex',
                        justifyContent: 'left'
                    }}
                />
            ),
            label: t('Common.microsoft_sso')
        }
    };

    return (
        <Box display="flex" width="100%">
            <LightTooltip
                title={
                    <Box padding="8px">
                        {Object.keys(ssoConfig).map(
                            (key) =>
                                ssoConfig[key].coverage !== 0 && (
                                    <Box
                                        key={`tooltip_${key}`}
                                        display="flex"
                                        alignItems="center"
                                        padding="8px"
                                    >
                                        <SSOAvatar
                                            key={`ssoAvatarTip_${key}`}
                                            config={ssoConfig[key]}
                                            noCount={noCount}
                                            showText={false}
                                        />
                                        <Box
                                            ml="4px"
                                            data-testid="ssoAvatarTooltip"
                                        >
                                            <Typography
                                                component="span"
                                                dangerouslySetInnerHTML={{
                                                    __html: t(
                                                        'SSOTypes.discoveredSSOClientsCount',
                                                        {
                                                            count: ssoConfig[
                                                                key
                                                            ].coverage,
                                                            ssoType:
                                                                ssoConfig[key]
                                                                    .label
                                                        }
                                                    )
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                )
                        )}
                    </Box>
                }
                arrow
                placement="right"
                PopperProps={{
                    sx: {
                        minWidth: '400px'
                    }
                }}
            >
                <AvatarGroup max={2} data-testid="ssosAvatarGroup">
                    {Object.keys(ssoConfig).map((key) =>
                        ssoConfig[key].coverage ? (
                            <SSOAvatar
                                key={`ssoAvatar_${key}`}
                                config={ssoConfig[key]}
                                noCount={noCount}
                                showText
                            />
                        ) : null
                    )}
                </AvatarGroup>
            </LightTooltip>
            {/* Display "Not available" if no counts are rendered */}
            {!noCount &&
                Object.keys(ssoConfig).every(
                    (key) => !ssoConfig[key].coverage
                ) && (
                    <Box width="100%">
                        <Typography variant="body1">
                            {t('SSOTypes.filter.notAvailable')}
                        </Typography>
                    </Box>
                )}
        </Box>
    );
};
